<template>
  <div class="message-box">
    <textarea class="emoji-area"></textarea>
    <div id="emojiarea-container"></div>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import emojioneArea from 'emojionearea/dist/emojionearea'

export default {
  data: () => ({
    el: null
  }),
  methods: {
    text () {
      return this.el.emojioneArea.getText()
    },
    clearText () {
      this.el.emojioneArea.setText('')
    }
  },
  mounted () {
    var e = $('.emoji-area').emojioneArea({
      container: '#emojiarea-container',
      hideSource: true,
      placeholder: this.$t('more.type_message_here'),
      inline: true,
      useSprite: true,
      dir: 'rtl',
      autocomplete: false
    })
    this.el = e[0]
  }
}
</script>

<style>
.message-box {
  position: relative;
  padding: 16px;
}
textarea {
  display: block;
  border: none;
  border-radius: 2px;
  outline: none;
  padding: 0.5rem;
  width: 95%;
  margin: auto;
  box-shadow: 0 2px 2px 0 rgba(0,0,0,.14), 0 3px 1px -2px rgba(0,0,0,.2), 0 1px 5px 0 rgba(0,0,0,.12);
}
.emojione, .emojibtn {
  width: 32px !important;
  height: 32px !important;
  background-image: unset !important;
}
.message-box {
  text-align: right;
}
.emojionearea-editor {
  direction: rtl;
}
</style>



// WEBPACK FOOTER //
// src/components/EmojiArea.vue